import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StyledHeaderButton } from '../Header/styles';
import Utils from '../../../utils';
import { StoreState } from '../../../reducers';
import { zoomPage } from '../../../containers/Editor/actions';
import { ZoomType } from '../../../containers/Editor/reducer';

interface ButtonZoomProps {
	isDisabled: boolean;
	dispatch: Dispatch<StoreState>;
}

const config = [
	{
		icon: 'iconset_uprez_zoom_out',
		zoom: ZoomType.OUT,
	},
	{
		icon: 'iconset_uprez_zoom_fit',
		zoom: ZoomType.FIT,
	},
	{
		icon: 'iconset_uprez_zoom_in',
		zoom: ZoomType.IN,
	},
];

const ButtonZoom = ({ isDisabled, dispatch }: ButtonZoomProps) => (
	<>
		{config.map(({ icon, zoom }) => (
			<StyledHeaderButton
				key={zoom}
				width="23px"
				height="23px"
				disabled={isDisabled}
				onClick={() => dispatch(zoomPage(zoom))}
			>
				{Utils.getSvgIcon(icon)}
			</StyledHeaderButton>
		))}
	</>
);

export default ButtonZoom;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonZoom/index.tsx